import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { visitedProducts } from './Reducers/VisitedProducts.reducer';
import { comparedProducts } from './Reducers/ComparedProducts.reducer';
import { tracking } from './Reducers/tracking.reducer';

const app = combineReducers({
  cart,
  checkout,
  quickSearch,
  navigation,
  myPage,
  facetedSearch,
  lightboxImages,
  visitedProducts,
  comparedProducts,
  tracking,
});

export default app;
